import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { USER_ROLES } from '../../utils/userRole'

export default function AuthRoutesWrapper({ children }) {
  const { user, user_role } = useSelector((state) => state.auth)
  let location = useLocation()

  if (user && user_role === USER_ROLES.ADMIN) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return <Navigate to='/' state={{ from: location }} replace />
  } else if (user && user_role === USER_ROLES.USER) {
    return <Navigate to='/ticket' state={{ from: location }} replace />
  }

  return <Outlet />
}
